import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { strings } from 'config';
import { numberTranslate } from 'utils';
import _ from 'lodash';

class Checkbox extends Component {
  getCount = (filter, title) => {
    const { dataList } = this.props;

    if (dataList) {
      if (filter === 'documentType') {
        return _.filter(dataList, {
          document_type: {
            en: title
          }
        });
      } else if (filter === 'documentSource') {
        return _.filter(dataList, {
          document_source: {
            en: title
          }
        });
      } else if (filter === 'subCategory') {
        return _.filter(dataList, {
          categories: [
            {
              subcategory: [
                {
                  title: title
                }
              ]
            }
          ]
        });
      } else if (filter === 'publishedDate') {
        return _.filter(dataList, {
          published_year: title
        });
      }
    }
  };

  render() {
    const { checked, onChange, titleNp, title, filter } = this.props;
    const selectedLang = strings.getLanguage();
    const subCategoryCount = this.getCount(filter, title);

    return (
      <CheckboxInput>
        <input type="checkbox" checked={checked} onChange={onChange.bind(null, title)} />
        <span className="checkbox" />
        {selectedLang === 'en' ? title : titleNp}{' '}
        {<Fragment>({subCategoryCount && numberTranslate(subCategoryCount.length)})</Fragment>}
      </CheckboxInput>
    );
  }
}

export default Checkbox;

export const CheckboxInput = styled.label`
  cursor: pointer;
  display: block;
  color: #4a4a4a;
  position: relative;
  font-size: 14px;
  padding-left: 20px;
  line-height: 1.5;
  span {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 1.4px solid #016bc2;
    border-radius: 2px;
    position: absolute;
    left: 0;
    top: 2px;
    &:before {
      content: '';
      position: absolute;
      left: 50%;
      top: 45%;
      transform: translate(-50%, -50%) rotate(-45deg);
      width: 50%;
      height: 30%;
      background: transparent;
      border-left: 2px solid #fff;
      border-bottom: 2px solid #fff;
      opacity: 0;
    }
  }
  input[type='checkbox'] {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 14px;
    height: 14px;
    line-height: 32px;
    border: none;
    z-index: 2;
    margin: 0; //-webkit-appearance: none;
    opacity: 0;
    outline: none;
  }
  input[type='checkbox']:checked ~ span.checkbox {
    background: #016bc2;
  }
  input[type='checkbox']:checked ~ span.checkbox:before {
    transform: translate(-50%, -50%) rotate(-45deg);
    opacity: 1;
    -webkit-filter: blur(0px);
    transition: all 0.3s ease;
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/checkboxTree/checkbox.js